function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M9.02855 2.86292L8.28286 5.10001C8.20323 5.3389 8.01577 5.52635 7.77689 5.60598L5.5398 6.35167C4.97561 6.53974 4.80658 7.25579 5.2271 7.67631L6.66397 9.11318L4.10225 11.6749C3.95811 11.819 3.9581 12.0528 4.10225 12.1969C4.24639 12.341 4.48009 12.341 4.62423 12.1969L7.18596 9.63517L8.52259 10.9718C8.94311 11.3923 9.65916 11.2233 9.84722 10.6591L10.5929 8.422C10.6725 8.18312 10.86 7.99567 11.0989 7.91604L13.336 7.17034C13.9002 6.98228 14.0692 6.26623 13.6487 5.84571L10.3532 2.55022C9.93266 2.1297 9.21662 2.29873 9.02855 2.86292Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTack);
export default __webpack_public_path__ + "static/media/tack.5e696e62b952e355f11d5652c414771d.svg";
export { ForwardRef as ReactComponent };